import React, {useReducer} from "react";
import { AlertContext } from "./alertContext";
import { alertReducer } from "./alertReducer";
import { HIDE_ALERTR, SHOW_ALERTR } from "../types";

export const AlertState = ({children}) => {
    const [state, dispatch] = useReducer(alertReducer,{visible: false});

    const show = (text, type = 'warning') => {
        dispatch({
            type: SHOW_ALERTR,
            payload: {text, type}
        })
    }

    const hide = () => dispatch({type: HIDE_ALERTR});

    return (
        <AlertContext.Provider value={{
            show, hide,
            alert: state,
        }}>
            {children}
        </AlertContext.Provider>
    )
}